export type SkyTone = "sunrise" | "sun" | "sunset" | "moon";

export interface CloudPalette {
  top: string;
  horizon: string;
  bottom: string;
  cloud: string;
  ink: string;
  rim: string;
  cloudOpacity: number;
  inkOpacity: number;
  stars: number;
}

export const SKY_PALETTES: Record<SkyTone, CloudPalette> = {
  sunrise: {
    top: "#9cc8ed",
    horizon: "#c3cac2",
    bottom: "#f4ce8f",
    cloud: "#f4eee3",
    ink: "#58586a",
    rim: "#f4c98d",
    cloudOpacity: 0.98,
    inkOpacity: 0.58,
    stars: 0,
  },
  sun: {
    top: "#346ff9",
    horizon: "#5093fb",
    bottom: "#88c3fd",
    cloud: "#f8f5ed",
    ink: "#667da4",
    rim: "#c9efff",
    cloudOpacity: 0.98,
    inkOpacity: 0.48,
    stars: 0,
  },
  sunset: {
    top: "#ae96ea",
    horizon: "#cdaebe",
    bottom: "#f7cb8e",
    cloud: "#f5eef2",
    ink: "#746a82",
    rim: "#ffe0ad",
    cloudOpacity: 0.98,
    inkOpacity: 0.48,
    stars: 0.08,
  },
  moon: {
    top: "#193064",
    horizon: "#173976",
    bottom: "#1d5494",
    cloud: "#9eacbf",
    ink: "#10182b",
    rim: "#c8d7ed",
    cloudOpacity: 0.94,
    inkOpacity: 0.66,
    stars: 0.78,
  },
};

export const SKY_TONE_DURATION = 1200;
